import pick from "lodash/pick";
import { FilterKeyV2, FiltersV2 } from "PFTypes/filters_v2";

export const getFiltersSubset = (filters: FiltersV2, subset: FilterKeyV2[] = []) =>
  (subset.length > 0 ? pick(filters, subset) : filters) as FiltersV2;
